document.addEventListener("DOMContentLoaded", function () {
  const menuTabs = document.querySelectorAll(
    ".menu-tabs__list .collection-menu__item"
  );

  if (menuTabs.length === 0) {
    return;
  }

  let manualTabSelection = false;

  function setActiveTab(clickedTab) {
    // Clear all active states first
    menuTabs.forEach((tab) => {
      tab.classList.remove("active");
    });

    // Clear all header menu active states
    const headerMenuItems = document.querySelectorAll(
      ".header__menu-item span[data-name]"
    );
    headerMenuItems.forEach((headerItem) => {
      const parentAnchor = headerItem.closest(".header__menu-item");
      if (parentAnchor) {
        parentAnchor.classList.remove("active");
        headerItem.classList.remove("header__active-menu-item");
      }
    });

    if (clickedTab) {
      clickedTab.classList.add("active");

      // Also update header menu items
      const tabHandle = clickedTab.getAttribute("data-menu-handle");

      headerMenuItems.forEach((headerItem) => {
        const parentAnchor = headerItem.closest(".header__menu-item");
        if (parentAnchor) {
          const headerHandle = headerItem.getAttribute("data-name");
          if (headerHandle === tabHandle) {
            parentAnchor.classList.add("active");
            headerItem.classList.add("header__active-menu-item");
          }
        }
      });
    }
  }

  function findMenuTabByHandle(handle) {
    const foundTab = Array.from(menuTabs).find((tab) => {
      const tabHandle = tab.getAttribute("data-menu-handle");
      return tabHandle === handle;
    });
    return foundTab;
  }

  menuTabs.forEach((tab) => {
    tab.addEventListener("click", function (e) {
      const href = this.getAttribute("href");

      if (href === "#" || href === "") {
        e.preventDefault();

        if (href === "#") {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }
      }

      manualTabSelection = true;
      setActiveTab(this);
    });
  });

  function determineActiveTab() {
    const currentPath = window.location.pathname;
    const currentHash = window.location.hash;

    let activeHandle = null;

    if (currentHash && currentHash.length > 1) {
      activeHandle = currentHash.substring(1);
    }

    if (!activeHandle) {
      const isCollectionPage = currentPath.includes("/collections/");
      if (isCollectionPage) {
        const collectionHandle = currentPath
          .split("/collections/")[1]
          ?.split("/")[0];
        if (collectionHandle) {
          if (collectionHandle === "all") {
            activeHandle =
              menuTabs.length > 0
                ? menuTabs[0].getAttribute("data-menu-handle")
                : null;
          } else {
            activeHandle = collectionHandle;
          }
        }
      }
    }

    if (!activeHandle) {
      const visibleCollectionSections = document.querySelectorAll(
        '[id^="shell"], [id^="deodorant"], [id^="bundle"], [id^="refills"]'
      );

      if (visibleCollectionSections.length > 0) {
        for (let section of visibleCollectionSections) {
          const rect = section.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.bottom > 0) {
            activeHandle = section.id;
            break;
          }
        }
      }
    }

    const activeTab = Array.from(menuTabs).find((tab) => {
      const handle = tab.getAttribute("data-menu-handle");
      return handle === activeHandle;
    });

    if (!activeTab) {
      return Array.from(menuTabs).find((tab) => {
        const handle = tab.getAttribute("data-menu-handle");
        return handle === "view-all";
      });
    }

    return activeTab;
  }

  // Always set first tab as active by default
  if (menuTabs.length > 0) {
    setActiveTab(menuTabs[0]);
  }

  function initHeaderMenuSync() {
    const headerMenuItems = document.querySelectorAll(
      ".header__menu-item span[data-name]"
    );

    headerMenuItems.forEach((headerItem) => {
      const parentAnchor = headerItem.closest(".header__menu-item");

      if (parentAnchor) {
        parentAnchor.addEventListener("click", function (e) {
          const menuHandle = headerItem.getAttribute("data-name");
          const correspondingTab = findMenuTabByHandle(menuHandle);

          if (correspondingTab) {
            manualTabSelection = true;
            setActiveTab(correspondingTab);
          } else {
            const href = parentAnchor.getAttribute("href");
            if (href && href.includes("/collections/")) {
              const collectionHandle = href
                .split("/collections/")[1]
                ?.split("/")[0];
              if (collectionHandle && collectionHandle !== "all") {
                const targetTab = Array.from(menuTabs).find((tab) => {
                  const handle = tab.getAttribute("data-menu-handle");
                  return handle === collectionHandle;
                });

                if (targetTab) {
                  manualTabSelection = true;
                  setActiveTab(targetTab);
                }
              } else {
                // For "view-all" or other cases, activate first tab
                manualTabSelection = true;
                setActiveTab(menuTabs[0]);
              }
            }
          }
        });
      }
    });
  }

  initHeaderMenuSync();

  function updateActiveTabOnPageChange() {
    if (manualTabSelection) {
      return;
    }

    const newActiveTab = determineActiveTab();
    if (newActiveTab) {
      setActiveTab(newActiveTab);
    }
  }

  window.addEventListener("popstate", updateActiveTabOnPageChange);
  window.addEventListener("hashchange", updateActiveTabOnPageChange);
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) {
      updateActiveTabOnPageChange();
    }
  });

  function initStickyMenuTabs() {
    const stickyMenuTabs = document.querySelectorAll(
      '.menu-tabs[data-sticky="true"]'
    );

    if (stickyMenuTabs.length === 0) return;

    stickyMenuTabs.forEach((menuTab) => {
      const originalOffset = menuTab.offsetTop;
      const originalHeight = menuTab.offsetHeight;

      function handleScroll() {
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > originalOffset) {
          menuTab.classList.add("menu-tabs--sticky");
          document.body.classList.add("menu-tabs-sticky-active");
        } else {
          menuTab.classList.remove("menu-tabs--sticky");
          document.body.classList.remove("menu-tabs-sticky-active");
        }
      }

      // Add scroll event listener
      window.addEventListener("scroll", handleScroll);

      handleScroll();
    });
  }

  initStickyMenuTabs();
  initScrollTabs();

  function initScrollTabs() {
    const sections = document.querySelectorAll(
      '[id^="shell"], [id^="deodorant"], [id^="bundle"], [id^="refills"], [id^="view-all"]'
    );
    if (sections.length === 0) return;

    let manualTabSelection = false;
    const observer = new IntersectionObserver(
      (entries) => {
        if (manualTabSelection) return;

        let visibleSection = null;
        let maxRatio = 0;

        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
            maxRatio = entry.intersectionRatio;
            visibleSection = entry.target;
          }
        });

        if (visibleSection && maxRatio > 0.3) {
          const tab = findMenuTabByHandle(visibleSection.id);
          if (tab) setActiveTab(tab);
        }
      },
      {
        rootMargin: "-10% 0px -60% 0px",
        threshold: [0, 0.3, 0.6, 1],
      }
    );

    sections.forEach((section) => observer.observe(section));

    const originalSetActiveTab = setActiveTab;
    setActiveTab = function (tab) {
      originalSetActiveTab(tab);
      manualTabSelection = true;
    };

    window.addEventListener("scroll", () => {
      if (manualTabSelection) {
        manualTabSelection = false;
      }

      // Check if scrolled back to top
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop < 100 && !manualTabSelection) {
        setActiveTab(menuTabs[0]);
      }
    });
  }
});
